export const FIRST_BTN = "FIRST_BTN";
export const MIDDLE_BTN = "MIDDLE_BTN";
export const LAST_BTN = "LAST_BTN";
export const SINGLE_BTN = "SINGLE_BTN";

export default function GroupButton({
  children,
  onClick,
  buttonType,
  disabled = false,
  badgeNum = 0,
}) {
  const styles = {
    [FIRST_BTN]: "rounded-l",
    [MIDDLE_BTN]: "border-l-0 rounded-l-none",
    [LAST_BTN]: "border-l-0 rounded-r rounded-l-none",
    [SINGLE_BTN]: "rounded",
  };

  const buttonStyles = styles[buttonType];

  return (
    <button
      className={`relative text-center border ${buttonStyles} border-gray-300 bg-white
       px-4 py-1.5 font-semibold text-xs rounded-l enabled:hover:bg-altgray-100 enabled:active:bg-altgray-50
       ${disabled && "btn-disabled"}
       `}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {badgeNum > 0 && <div className="badge">{badgeNum}</div>}
    </button>
  );
}
